import React from "react";

export const Email = () => (
    <React.Fragment>
        <a href="mailto:roland@novacarrierscorp.com"
           target="_top">roland@novacarrierscorp.com</a>
    </React.Fragment>
);
